import { useEffect, useState } from 'react';
import { useAdmin } from '@/hooks/useAdmin';
import { Eye, Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ['site_name', 'Naziv portala'],
  ['tagline', 'Slogan'],
  ['contact_email', 'Kontakt email'],
  ['contact_phone', 'Kontakt telefon'],
  ['logo_url', 'URL loga'],
  ['favicon_url', 'URL favicona'],
  ['primary_color', 'Primarna boja (hex)'],
  ['social_facebook', 'Facebook URL'],
  ['social_instagram', 'Instagram URL'],
  ['social_x', 'X (Twitter) URL'],
  ['social_youtube', 'YouTube URL'],
  ['address', 'Adresa'],
  ['vat_id', 'OIB / VAT'],
  ['footer_text', 'Tekst u footeru'],
];

export default function AdminPortalManage() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { (async () => {
    const r = await authFetch(`${API}/admin/portal-branding`);
    if (r.ok) setData(await r.json());
    setLoading(false);
  })(); /* eslint-disable-next-line */ }, []);

  const save = async () => {
    setSaving(true);
    const r = await authFetch(`${API}/admin/portal-branding`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (r.ok) toast.success('Spremljeno'); else toast.error('Greška');
    setSaving(false);
  };

  if (loading) return <div className="p-10"><Loader2 className="animate-spin text-zinc-500" /></div>;

  return (
    <div className="p-4 md:p-6 max-w-4xl" data-testid="admin-portal-manage">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <Eye className="text-red-500" size={24} />
          <div>
            <h1 className="text-2xl font-bold">Upravljanje portalom</h1>
            <p className="text-sm text-zinc-400">Glavni podaci portala, brendiranje, kontakti i društvene mreže.</p>
          </div>
        </div>
        <button onClick={save} disabled={saving} data-testid="pm-save-btn"
                className="inline-flex items-center gap-1 px-3 py-2 bg-red-600 hover:bg-red-700 rounded text-sm font-bold disabled:opacity-50">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Spremi
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="text-xs text-zinc-400">{label}</label>
            <input value={data[k] || ''} onChange={e => setData({ ...data, [k]: e.target.value })}
                   data-testid={`pm-${k}`}
                   className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-1.5 text-sm" />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-zinc-500 mt-4">
        Ove vrijednosti čita javni portal preko <code>/api/public/portal-branding</code> i koristi ih u headeru,
        footeru, Open Graph meta podacima i kontakt stranici.
      </p>
    </div>
  );
}
